
import { BaseVue } from "@newview/base-web";
import { Component } from "vue-property-decorator";
@Component({
  name: "subSystem",
  components: {
  },
})
export default class subSystem extends BaseVue {
  roleInfos: any = this.$globalData.roleInfos;
  subSystemMenuItems: any = this.$globalData.subSystemMenuItems;
  created(){
  }
  mounted() {
    
  }
}
